/**
 * Session-ended copy for the shared AvatarModal teardown state.
 *
 * AI Interviewer and AI Counsellor share the modal and finalization flow, but
 * the heading must stay specific to the service the student used. Unknown or
 * legacy modes keep the interviewer copy so existing tutor behaviour is
 * unchanged.
 */
const SESSION_ENDED_TITLES = {
  interviewer: 'Interview Ended',
  counsellor: 'Counselling Ended',
};

export const getSessionEndedTitle = (mode) =>
  SESSION_ENDED_TITLES[mode] || SESSION_ENDED_TITLES.interviewer;
